import { createFileRoute, redirect } from '@tanstack/react-router';

import { parseOverviewView } from '@/areas/sourcing-scenarios/SourcingScenarios/SourcingOverviewPage/overviewView';
import SourcingOverviewPage from '@/areas/sourcing-scenarios/SourcingScenarios/SourcingOverviewPage/SourcingOverviewPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// An unknown `$view`, or demand groups with their flag off, goes to the scenarios, so the address bar names the view.
export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/overview/$view')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    beforeLoad: ({ context, params }) => {
        const overviewView = parseOverviewView(params.view);
        if (
            overviewView === undefined ||
            (overviewView === 'demandGroups' && !context.session.isFeatureFlagEnabled('is_demand_groups_enabled'))
        ) {
            throw redirect({
                to: '/projects/$projectId/sourcing/overview/$view',
                params: { projectId: params.projectId, view: 'scenarios' },
                replace: true,
            });
        }
        return { overviewView };
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const projectId = Route.useParams({ select: (params) => params.projectId });
    const view = Route.useRouteContext({ select: (context) => context.overviewView });
    return <SourcingOverviewPage projectId={projectId} view={view} />;
}
